import {request, setCsrfToken} from './http';
import {config} from '../utils/config';
import type {User} from '../types/models';

export interface LoginPayload {
  username?: string;
  email?: string;
  password: string;
}

export interface RegisterPayload {
  username: string;
  email: string;
  password: string;
  password_confirm?: string;
}

interface CsrfResponse {
  csrfToken: string;
}

interface UserResponse {
  user: User;
}

export const authApi = {
  async csrf(): Promise<string> {
    const response = await request<CsrfResponse>(config.auth.csrf);
    setCsrfToken(response.csrfToken);
    return response.csrfToken;
  },

  login: (payload: LoginPayload) =>
    request<UserResponse>(config.auth.login, {
      method: 'POST',
      body: JSON.stringify(payload),
    }),

  register: (payload: RegisterPayload) =>
    request<UserResponse>(config.auth.register, {
      method: 'POST',
      body: JSON.stringify(payload),
    }),

  me: () => request<User>(config.auth.me),

  logout: () =>
    request<void>(config.auth.logout, {
      method: 'POST',
      body: '{}',
    }),
};
